import RequestCache from "./RequestCache";

export default class Phrase extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.phrase;
    }
}
